/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EvaluationReportResponseDto } from '../../models/evaluation-report-response-dto';
import { RequestEvaluationReportGenDto } from '../../models/request-evaluation-report-gen-dto';

export interface DocumentAiV2ControllerGenerateEvaluationReport$Params {
  centerId: string;
  type: 'user' | 'center';
      body: RequestEvaluationReportGenDto
}

export function documentAiV2ControllerGenerateEvaluationReport(http: HttpClient, rootUrl: string, params: DocumentAiV2ControllerGenerateEvaluationReport$Params, context?: HttpContext): Observable<StrictHttpResponse<EvaluationReportResponseDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiV2ControllerGenerateEvaluationReport.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.query('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EvaluationReportResponseDto>;
    })
  );
}

documentAiV2ControllerGenerateEvaluationReport.PATH = '/api/document-ai-v2/evaluation-report-ai';
